// frontend/src/components/OrdenesCompraResumen.jsx
import React, { useState, useEffect } from 'react';
import presupuestosService from '../services/presupuestosService';
import './OrdenesCompraResumen.css';

import Loading from './Loading';
const OrdenesCompraResumen = ({ periodo }) => {
  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ocPorStatus, setOcPorStatus] = useState({
    pendiente: [],
    enviada_emitir: [],
    emitida: [],
    cancelada: []
  });

  useEffect(() => {
    cargarOrdenesCompra();
  }, [periodo]);

  const cargarOrdenesCompra = async () => {
    try {
      setLoading(true);
      // Cargar todas las órdenes de compra del período actual
      const response = await presupuestosService.getOrdenesCompra();
      let ocData = [];

      if (response.data && response.data.results && Array.isArray(response.data.results)) {
        ocData = response.data.results;
      } else if (Array.isArray(response.data)) {
        ocData = response.data;
      }

      setOrdenesCompra(ocData);

      // Agrupar por status
      const agrupadas = {
        pendiente: [],
        enviada_emitir: [],
        emitida: [],
        cancelada: []
      };

      ocData.forEach(oc => {
        if (agrupadas[oc.status]) {
          agrupadas[oc.status].push(oc);
        }
      });

      setOcPorStatus(agrupadas);
    } catch (error) {
      console.error('Error al cargar órdenes de compra:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusInfo = (status) => {
    const info = {
      pendiente: {
        label: 'Pendiente',
        icon: '⏳',
        color: '#fbbf24',
        bgColor: '#fffbeb',
        borderColor: '#fcd34d'
      },
      enviada_emitir: {
        label: 'Enviada a Emitir',
        icon: '📤',
        color: '#0284c7',
        bgColor: '#dbeafe',
        borderColor: '#7dd3fc'
      },
      emitida: {
        label: 'Emitida',
        icon: '✅',
        color: '#059669',
        bgColor: '#dcfce7',
        borderColor: '#86efac'
      },
      cancelada: {
        label: 'Cancelada',
        icon: '❌',
        color: '#dc2626',
        bgColor: '#fee2e2',
        borderColor: '#fca5a5'
      }
    };
    return info[status] || {};
  };

  if (loading) {
    return <Loading fullScreen={false} size="sm" mensaje="Cargando órdenes de compra" />;
  }

  const totalOcs = ordenesCompra.length;
  const totalMonto = ordenesCompra.reduce((total, oc) => total + oc.monto, 0);

  return (
    <div className="oc-resumen-container">
      <div className="oc-resumen-header">
        <h2>📋 Órdenes de Compra</h2>
        <div className="oc-resumen-stats">
          <div className="stat-item">
            <span className="stat-label">Cantidad OC:</span>
            <span className="stat-value">{totalOcs}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Monto Total:</span>
            <span className="stat-value">${totalMonto.toLocaleString('es-CL', { maximumFractionDigits: 0 })}</span>
          </div>
        </div>
      </div>

      <div className="oc-status-cards">
        {Object.entries(ocPorStatus).map(([status, ocs]) => {
          const info = getStatusInfo(status);
          const count = ocs.length;

          return (
            <div
              key={status}
              className="oc-status-card"
              style={{
                backgroundColor: info.bgColor,
                borderColor: info.borderColor,
                borderLeft: `4px solid ${info.color}`
              }}
            >
              <div className="card-header">
                <div className="header-content">
                  <span className="status-icon">{info.icon}</span>
                  <h3>{info.label}</h3>
                </div>
              </div>

              <div className="card-content">
                <div className="metric">
                  <span className="metric-value" style={{ color: info.color }}>
                    {count}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {totalOcs === 0 && (
        <div className="oc-empty-state">
          <p>📭 No hay órdenes de compra registradas</p>
        </div>
      )}
    </div>
  );
};

export default OrdenesCompraResumen;
